import { ERROR_TEXT } from "../container/constants";

/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
const stringInterpolation = (replaceArr: string[], sentence: string = ERROR_TEXT) => {
    return replaceArr.reduce((f, s, i) => `${f}`.replace(`{${i}}`, s), sentence);
}
export default stringInterpolation;